import { Injectable } from '@angular/core';
import { collection, deleteDoc, doc, getDocs, getFirestore } from 'firebase/firestore';

import { currentUserUid } from '../../../../utils/firestore-ownership';
import { currentTrustedDeviceId, forgetTrustedDevice } from '../../sign-in/trusted-device';

export interface TrustedDevice {
  id: string,
  label: string,
  createdAt: Date | null,
  lastUsedAt: Date | null,
  expiresAt: Date | null,
  // This browser
  current: boolean
}

// Devices that skip the TOTP code (users/{uid}/trustedDevices); created by the Cloud Functions
@Injectable({
  providedIn: 'root'
})
export class TrustedDevicesService {

  async list(): Promise<TrustedDevice[]> {
    const uid = currentUserUid();
    const current = currentTrustedDeviceId(uid);
    const docs = await getDocs(collection(getFirestore(), 'users', uid, 'trustedDevices'));
    const now = Date.now();

    return docs.docs
      .map(d => ({
        id: d.id,
        label: d.data()['label'] ?? 'Dispositivo',
        createdAt: d.data()['createdAt']?.toDate() ?? null,
        lastUsedAt: d.data()['lastUsedAt']?.toDate() ?? null,
        expiresAt: d.data()['expiresAt']?.toDate() ?? null,
        current: d.id == current
      }))
      // Expired ones no longer skip the code; the Cloud Function deletes them on the next use
      .filter(d => !d.expiresAt || d.expiresAt.getTime() > now)
      .sort((a, b) => Number(b.current) - Number(a.current) || (b.lastUsedAt?.getTime() ?? 0) - (a.lastUsedAt?.getTime() ?? 0));
  }

  // The next sign-in on that device asks for the TOTP code again
  async revoke(device: TrustedDevice): Promise<void> {
    await deleteDoc(doc(getFirestore(), 'users', currentUserUid(), 'trustedDevices', device.id));
    if (device.current) forgetTrustedDevice();
  }
}
